import { userHasRole } from "../utils/policyUtils.js";

export default {
  viewAny: ({ user, claim }) => {
    // check if user kunde_id_ov matches claim kunde_id_ov
    if (
      userHasRole(
        ["sysadmin", "makler_sachbearbeitung", "makler_buchhaltung"] &&
          user.kunde_id_ov &&
          claim.kunde_id_ov &&
          user.kunde_id_ov === claim.kunde_id_ov
      )
    ) {
      return true;
    }

    return false;
  },

  messageInsurer: ({ user }) => {
    if (userHasRole(user, ["sysadmin", "makler_sachbearbeitung", "makler_buchhaltung"])) {
      return true;
    }

    return false;
  },

  forward: ({ user, communication }) => {
    if (userHasRole(user, ["sysadmin", "makler_sachbearbeitung", "makler_buchhaltung"])) {
      return (
        communication.sent_at &&
        (communication.type === "insurer_email" ||
          communication.type === "tenant_message" ||
          communication.type === "customer_message")
      );
    }

    return false;
  },

  remind: ({ user, communication }) => {
    return true;
  },

  createEmail: ({ user }) => {
    if (userHasRole(user, ["sysadmin", "makler_sachbearbeitung", "makler_buchhaltung"])) {
      return true;
    }

    return false;
  },

  delete: ({ user, communication }) => {
    if (communication.created_by?.id === user.id && communication.type !== "system_message") {
      return true;
    }
    if (!userHasRole(user, ["sysadmin", "makler_sachbearbeitung"])) {
      return false;
    }

    // Cannot delete internal communications created by customer users
    if (communication?.intern && communication?.created_by?.kunde_id_ov) {
      return false;
    }

    return true;
  },
};
